import {startTransition, useCallback, useEffect, useState} from 'react';

/**
 * Хук для отслеживания  media query в state.
 * @param query - css media query, например (max-width:600px)
 * @returns true - query соответствует экрану, false - не соответсвует
 */
export const useMediaQuery = (query: string): boolean | null => {
    const supportMatchMedia =
        typeof window !== 'undefined' &&
        typeof window.matchMedia !== 'undefined';

    const getMatches = useCallback(
        (query: string) => {
            if (supportMatchMedia) {
                return window.matchMedia(query).matches;
            }
            return null;
        },
        [supportMatchMedia],
    );

    const [matches, setMatches] = useState<boolean | null>(getMatches(query));

    const handleChange = useCallback(() => {
        startTransition(() => setMatches(getMatches(query)));
    }, [query, getMatches]);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);

        // addListener и removeListener deprecated (оставлены для поддержки Safari <14)
        if (mediaQueryList.addListener) {
            mediaQueryList.addListener(handleChange);
        } else {
            mediaQueryList.addEventListener('change', handleChange);
        }

        return () => {
            if (mediaQueryList.removeListener) {
                mediaQueryList.removeListener(handleChange);
            } else {
                mediaQueryList.removeEventListener('change', handleChange);
            }
        };
    }, [query, handleChange]);

    return matches;
};
